import { CustomPalette } from '@customTypes/createPalette'
import { Global } from '@emotion/react'

const CSSVariables = ({ theme }: { theme: CustomPalette }) => {
	const { backgroundColors, borderColors, fonts } = theme
	const vars = [backgroundColors, borderColors, fonts].flatMap(el =>
		Object.entries(el).map(([key, val]) => `--${key}: ${val};`)
	)
	return <Global styles={vars.join('')} />
}

export { CSSVariables }
